import React from "react";
import { Link } from "react-router-dom";
import downArrow from "../assets/downArrow.png";

const AmlPolicy = () => {
  return (
    <div className="bg-black text-white min-h-screen flex flex-col items-center px-8 py-10">
      {/* Back Button */}
      {/* <div className="absolute top-5 left-5">
        <Link to="/" className="text-white flex items-center space-x-2">
          <span className="text-2xl">&larr;</span>
          <span className="text-white">Back</span>
        </Link>
      </div> */}

      {/* Title */}
      <h1 className="text-primary text-4xl font-bold mb-2">Anti-Money Laundering (AML) Policy</h1>
      <div className="flex justify-center">
        <img src={downArrow} alt="Arrow Down" className="h-7  mt-6 mb-6" />
      </div>
      {/* Content */}
      <div className="max-w-4xl space-y-6 text-left">
        {/* Introduction */}
        <section>
          <h2 className="text-primary text-2xl font-semibold mb-2">Introduction</h2>
          <p>
            This policy of Futcoinspot prohibits and actively pursues the prevention of money laundering and any activity that facilitates money laundering or the financing of terrorist and terrorist activities. Futcoinspot requires its managers, employees, and affiliates to adhere to the policy in preventing the use of the Company Services for money laundering purposes.
          </p>
        </section>

        {/* Legal Bases */}
        <section>
          <h2 className="text-primary text-2xl font-semibold mb-2">Legal Bases</h2>
          <p>
            Futcoinspot operates in jurisdictions with stringent Anti-Money Laundering (AML) regulations. We are committed to working with local financial authorities, and Futcoinspot is committed to complying with international standards and local laws and jurisdictions, strengthening and adapting our internal controls to combat illegal activities.
          </p>
          <ul className="list-disc list-inside space-y-2 mt-2">
            <li>FATF 40 Recommendations</li>
            <li>The US Bank Secrecy Act (BSA) and the US Anti-Money Laundering, Terrorist Financing and Foreign Sanctions Act (AML Act)</li>
            <li>UK Money Laundering Regulations (MLR) and Proceeds of Crime Act (PACE)</li>
            <li>EU Anti-Money Laundering Directive and Regulations</li>
            <li>CN Anti-Money Laundering and Countering the Financing of Terrorism Law</li>
          </ul>
        </section>

        {/* Transaction Monitoring and Evaluation */}
        <section>
          <h2 className="text-primary text-2xl font-semibold mb-2">Transaction Monitoring and Evaluation</h2>
          <p>
            Futcoinspot will implement an effective transaction monitoring mechanism to identify and investigate transactions that may involve money laundering or other irregular activities through systematic and manual reviews.
          </p>
          <ul className="list-disc list-inside space-y-2 mt-2">
            <li>If transactions occur frequently or exceed a reasonable range, they may be marked as suspicious.</li>
            <li>Restrictive measures may be taken if a transaction is deemed suspicious.</li>
            <li>Records such as customer identification documents and transaction logs are retained as per regulatory requirements.</li>
            <li>Suspicious transactions may be reported to law enforcement agencies.</li>
          </ul>
        </section>

        {/* User Suspicious Activity */}
        <section>
          <h2 className="text-primary text-2xl font-semibold mb-2">User Suspicious Activity</h2>
          <p>We will monitor suspicious activities including:</p>
          <ul className="list-disc list-inside space-y-2 mt-2">
            <li>A customer providing false or insufficient information.</li>
            <li>Requests for cash payments or third-party payments without logical connection.</li>
            <li>Payments from high-risk countries or overpayments followed by refund requests.</li>
            <li>Unexpected spikes in a customer’s activities or self-purchases.</li>
            <li>Registering or using more than one Futcoinspot account.</li>
          </ul>
        </section>

        {/* Futcoinspot Rights and Duties */}
        <section>
          <h2 className="text-primary text-2xl font-semibold mb-2">Futcoinspot Rights and Duties</h2>
          <ul className="list-disc list-inside space-y-2 mt-2">
            <li>Verify Buyer and payments, and hold them until the order's completion.</li>
            <li>Protect Sellers from fraudulent payments and make appropriate refunds.</li>
            <li>Review trading history, communications, and more to resolve disputes.</li>
            <li>Pursue legal action against fraudulent activities.</li>
          </ul>
        </section>

        {/* Policy Updates and Tips */}
        <section>
          <h2 className="text-primary text-2xl font-semibold mb-2">Policy Updates and Tips</h2>
          <p>
            Futcoinspot will periodically review and update this policy. Users will be notified of changes.
          </p>
        </section>
      </div>
    </div>
  );
};

export default AmlPolicy;
